import axios from "../../axiosConfig";

export const updateBuildWeeks = async ({ valuesList, token }) => {
  if (!token || !valuesList) throw new Error("Missing token or values data");

  const response = await axios.put(
    `/updateBuildWeeks`,
    valuesList,
    {
      headers: {
        Authorization: token,
      },
    }
  );

  return response.status;
};